module.exports = __webpack_public_path__ + "weibo.svg?29eb20eea609eef3938880f29fa1a562";